import React from "react";
/** Sort arrows (16×16), inherits color via currentColor. */
export default function IconSort({ className, }) {
    return (<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M10.0001 1.99992L10.6667 1.33325L11.3334 1.99992V12.3903L13.724 9.99961H14.6667V10.9426L11.138 14.4713H10.1954L6.66673 10.9426V9.99961H7.60939L10.0001 12.3903V1.99992Z" fill="currentColor"/>
      <path d="M4.86203 1.52855H5.80503L9.33369 5.05723V5.9999H8.39069L6.00036 3.60922V13.9999L5.33336 14.6666L4.6667 13.9999V3.60922L2.27604 5.9999H1.33337V5.05723L4.86203 1.52855Z" fill="currentColor"/>
    </svg>);
}
